import { Comment } from '@/models/Posts';
import { Product, Product2 } from '@/models/Product';
import { get } from '@/utils/axios';
interface Params {
  url?: string;
  product_id?: number;
  vendor_id?: number;
  page_size?: number;
  page?: number;
}
interface ApiResponse {
  count: number;
  next: string | null;
  previous: string | null;
  success: boolean;
  product_id: number;
  products: Product2[];
}
const fetchProductGroup = async (params?: Partial<Params>) => {
  const newUrl = params?.url || '/hyperlocal/v1/product-groups';
  try {
    return await get<ApiResponse>(newUrl, params);
  } catch (error) {
    console.error(error);
  }
  return null;
};
export default fetchProductGroup;